import http from '../../../utils/http'
import security from '../../../utils/security'

const state = {
  loading: false,
  error: null,
  config: {
    company: {},
    fileTypes: {},
    transferTypes: {},
    deductionTypes: {},
    currencyTypes: {},
    userRoles: {},
    agreementStatus: {}
  }
}

const getters = {
  userRoles: function (state) {
    return state.config.userRoles
  },
  fileTypes: function (state) {
    return state.config.fileTypes
  },
  currencyTypes: function (state) {
    return state.config.currencyTypes
  },
  deductionTypes: function (state) {
    return state.config.deductionTypes
  },
  transferTypes: function (state) {
    return state.config.transferTypes
  },
  invoicePaymentType: function (state) {
    return state.config.invoicePaymentType
  },
  invoiceTaxType: function (state) {
    return state.config.invoiceTaxType
  },
  agreementStatus: function (state) {
    return state.config.agreementStatus
  },
  company: function (state) {
    return state.config.company
  },
  config: function (state) {
    return state.config
  },
  loading: function () {
    return state.loading
  },
  error: function () {
    return state.error
  }
}

const actions = {
  loadConfig ({commit}, values) {
    commit('CONFIG_LOADING', true)

    return http.fetch('/config_values', {method: 'GET'})
      .then(function (response) { return response.json() })
      .then(function (data) {
        commit('CONFIG_LOADING', false)
        commit('CONFIG_CONFIG', {
          fileTypes: data.fileTypes['hydra:member'],
          currencyTypes: data.currencyTypes['hydra:member'],
          transferTypes: data.transferTypes['hydra:member'],
          deductionTypes: data.deductionTypes['hydra:member'],
          invoicePaymentType: data.invoicePaymentType['hydra:member'],
          invoiceTaxType: data.invoiceTaxType['hydra:member'],
          company: data.company,
          userRoles: data.userRoles,
          agreementStatus: data.agreementStatus,
          agreementDocumentType: data.agreementDocumentType,
        })
      })
      .catch(e => {
        commit('CONFIG_LOADING', false)
        if (security.handleAuthorizationError(e)) {
          return
        }
        commit('CONFIG_ERROR', e.message)
      })

  },
}

const mutations = {
  CONFIG_LOADING (state, payload) {
    state.loading = payload
  },
  CONFIG_CONFIG (state, payload) {
    state.config = payload
  },
  CONFIG_ERROR (state, payload) {
    state.error = payload
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/config/config.js